import React from 'react'
import { PlayButton } from 'ui/buttons'

function TrackButton ({ children, onClick }) {
  const handleOnClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e)
    }
  }

  return (
    <div className='inline-flex items-center'>
      <div className='mr-8 font-medium text-xl'>
        {children}
      </div>
      <PlayButton onClick={e => handleOnClick(e)} />
    </div>
  )
}

TrackButton.defaultProps = {
  isPlaying: false
}

export default TrackButton
